import React, { useEffect } from 'react';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
} from '@roger/ui-components';

const LoginPage: React.FC = () => {
  const { loginWithWorkOS, isAuthLoading } = useStore(
    useShallow(state => ({
      loginWithWorkOS: state.loginWithWorkOS,
      isAuthLoading: state.isAuthLoading,
    }))
  );

  useEffect(() => {
    // Automatically redirect to WorkOS login when component mounts
    loginWithWorkOS();
  }, [loginWithWorkOS]);

  return (
    <div className='min-h-screen bg-background flex items-center justify-center p-4'>
      <Card className='w-full max-w-md'>
        <CardHeader className='text-center'>
          {/* Roger Logo */}
          <img
            src='https://cdn.prod.website-files.com/6707130d88e878564ebeead2/6707e3f0baed2cc2cc663543_Group%205301.svg'
            alt='Roger Logo'
            className='mx-auto mb-6 h-12 w-auto'
            style={{ maxHeight: 48 }}
          />

          <Typography variant='h3' as='h1' className='mb-4'>
            Welcome to Roger Healthcare
          </Typography>
        </CardHeader>

        <CardContent className='text-center'>
          <div className='flex items-center justify-center space-x-2 flex-col'>
            <div className='animate-spin rounded-full h-6 w-6 border-b-2 border-primary'></div>

            <Typography variant='lead' className='text-muted-foreground'>
              {isAuthLoading ? 'Redirecting to sign in...' : 'Signing in...'}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
